<script lang="ts" setup>

//vue
import { onMounted, reactive, watch } from "vue";
import { useRouter } from "vue-router";

//servicos
import * as service from "@/services/BoletosService";
import { f2dec, fdata} from "@/utils/funcoes";

//componentes
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import DropdownParamBoleto from "@/components/Dropdowns/DropdownParamBoleto.vue";
import Loading from "@/components/Loading/index.vue";

interface IProps {
    boletos: service.Boleto[],
    exibir: boolean
}

var props = defineProps<IProps>();
var emit = defineEmits(["gerou","erro", "fechou"]);

var router = useRouter();

var controle = reactive({ 
    
    janRemessa: false,
    param: {
        paramBoletoId: 1,
    } as service.GerarRemessaDTO,
    resumo: [] as IResumo[],
    remessa: {} as service.BoletoRemessa,
    gerou : false,
    loading: false,
    status: "",
    erro: ""
});

onMounted(() => {

    montarResumo();

})

watch(() => props.boletos, async(novoValor ) => {
    controle.param.boletosIds = novoValor.map(b => b.boletoId);
    
    montarResumo();
})

watch(() => props.exibir, async (novoValor) => {

    controle.janRemessa = novoValor;
    controle.gerou = false;

    if (controle.janRemessa == true)
    {
        setTimeout(() => {
            var jan = document.getElementById("janRemessa");
            var el = jan?.querySelector("#inputFocus") as HTMLInputElement;
            if (el != undefined)
                el.focus();
        }, 700);
    }

    montarResumo();

})



async function gerar(){

    controle.erro = "";
    controle.status = "";
    controle.loading = true;

    controle.status = `Gerando remessa ...`;
    
    console.log("Gerando remessa", controle.param);

    await service.gerarRemessa(controle.param)
    .then(r=> {
        controle.status =  `Gerado com sucesso!`;
        controle.gerou = true;
        controle.remessa = r;
        emit("gerou");

        setTimeout(() => {
            controle.loading = false;
            controle.janRemessa = false;
            router.push("/boletosRemessas");
        }, 1500);


    })
    .catch((erro) => {
        controle.erro = erro;
        controle.status = "Erro: " + erro ;
        controle.loading = false;
        emit("erro", erro);
    });
}

function fechar() {
    controle.janRemessa = false;
    emit("fechou");
}

interface IResumo {
    ocorrenciaId: string;
    descricao: string;
    qtde: number;
    total: number;
}

const montarResumo = ()=> {

    controle.resumo = [] as IResumo[];

    const grupos = Object.groupBy(props.boletos, ({ ocorrenciaId }) => ocorrenciaId);

    Object.keys(grupos).forEach(function (key: string) {

        var itens = props.boletos.filter(a => a.ocorrenciaId == key);

        if (itens.length == 0)
            return;
        
        var grupo = {
            ocorrenciaId: key,
            descricao: itens[0].ocorrencia?.descricao,
            qtde: itens.length,
            total: itens.reduce((total, boleto) => total + (boleto.valorDocumento ?? 0), 0)
        } as IResumo;

        controle.resumo.push(grupo);
    });
}

function baixar()
{
    controle.loading = true;
    controle.status = "Baixando arquivo de remessa...";

    service.baixarRemessa(controle.remessa.remessaId!)
        .then((r) => {
            controle.loading = false;
            controle.status = "";
            const link = document.createElement('a');
            link.href = 'data:text/plain;charset=utf-8,' + encodeURIComponent(r);
            link.download = `remessa_${controle.remessa?.paramBoletoId}_${fdata(new Date())}.txt`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch((erro: string) => {
            controle.loading = false;
            controle.status = "";
            MsgBox.showError("Erro ao baixar arquivo de remessa", erro);
        });
}

</script>



<template>
    <Loading :isLoading="controle.loading" :mensagem="controle.status" />

    <MsgBox :id="'janRemessa'" :titulo="'Gerar Remessa'"  :exibir="controle.janRemessa"  @onFechou="controle.janRemessa = false" >
        <TrataTecla>
       
            <div class="row mb-2">
                <div class="col-md-12">
                    <h5>Resumo dos boletos selecionados</h5>
                </div>
                <div class="col-md-12">
                    <table class="table table-sm table-bordered">
                        <thead>
                            <tr>
                                <th>Ocorrência</th>
                                <th>Código</th>
                                <th class="text-end">Qtde</th>
                                <th class="text-end">Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in controle.resumo" :key="item.ocorrenciaId">
                                <td>{{item.descricao}}</td>
                                <td>{{item.ocorrenciaId}}</td>
                                <td class="text-end">{{item.qtde}}</td>
                                <td class="text-end">R$ {{ f2dec(item.total) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="row mb-2">
                <div class="col-md-2">
                    Convênio
                </div>
                <div class="col-md-10">
                    <DropdownParamBoleto v-model="controle.param.paramBoletoId" id="inputFocus  "/>
                </div>
            </div>

             <div class="row mb-2">
                <div class="col-md-2">
                    Destino
                </div>
                <div class="col-md-10">
                    <select v-model="controle.param.destino" class="form-select form-select-sm">
                        <option value="arquivo">Arquivo</option>
                        <option value="api">Api</option>
                    </select>
                </div>
            </div>
            
            <div class="row mb-2" >
                <div class="col-md-2">
                    <label>Usuário</label>
                </div>
                <div class="col-md-4">
                     <input type="text" class="form-control form-control-sm" v-model="controle.param.nomeUsuario" id="nomeUsuario" ref="nomeUsuario">
                </div>
            </div>

            <div class="row mb-2" >
                <div class="col-md-2">
                      <label>Senha</label>
                </div>
                <div class="col-md-4">
                    <input type="password" class="form-control form-control-sm" v-model="controle.param.senha" ref="senha" >
                </div>
            </div>

            <div class="row" v-if="controle.erro != ''">
                <div class="col-md-3"></div>
                <div class="col-md-9 fw-bold text-danger">
                    {{controle.erro}}
                </div>
            </div>

            <div class="row" v-if="controle.status != '' && controle.erro == ''">
                <div class="col-md-3"></div>
                <div class="col-md-9 fw-bold ">
                    <i class="fa fa-cog fa-spin"></i> {{controle.status}}
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <hr>
                </div>
            </div>

            <div class="row">
                <div class="col-md-6">
                    <button type="button" class="btn btn-primary btn-sm" @click="gerar()" :disabled="controle.loading" v-if="!controle.gerou">Gerar</button>
                    <button type="button" class="btn btn-primary btn-sm" @click="baixar()"  v-if="controle.gerou == true">Baixar</button>
                </div>
                <div class="col-md-6">
                    <a class="btn btn-secondary btn-sm float-end" @click="fechar()" :disabled="controle.loading">Fechar</a>
                </div>
            </div>
        </TrataTecla>
    </MsgBox>
</template>